import { useNavigate } from 'react-router-dom';

const PaymentFailed = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-black flex items-center justify-center p-4">
      <div className="bg-[#ffffff] dark:bg-black border border-gray-200 dark:border-gray-800 rounded-lg shadow-lg p-8 max-w-md w-full text-center">
        {/* Error icon */}
        <div className="w-20 h-20 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-10 h-10 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>

        {/* Error message */}
        <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          Payment Failed
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Unfortunately, your payment could not be processed.
        </p>

        {/* Reasons */}
        <div className="bg-gray-50 dark:bg-black border border-gray-200 dark:border-gray-800 rounded-lg p-4 mb-6 text-left">
          <p className="text-sm text-gray-700 dark:text-gray-300 mb-2">Possible reasons:</p>
          <ul className="text-sm text-gray-600 dark:text-gray-400 space-y-1">
            <li>• Insufficient funds</li>
            <li>• Payment declined by bank</li>
            <li>• Network timeout</li>
            <li>• Incorrect payment details</li>
          </ul>
        </div>

        {/* Actions */}
        <div className="space-y-3">
          <button
            onClick={() => navigate(-1)}
            className="w-full bg-teal-600 text-white py-3 rounded-lg hover:bg-teal-700 transition"
          >
            Try Again
          </button>
          <button
            onClick={() => navigate('/')}
            className="w-full border border-gray-300 dark:border-gray-700 py-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-900 text-gray-700 dark:text-gray-300 transition"
          >
            Back to Home
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentFailed;
